var React = require('react');

function Gr (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#eee","d":"M0 122.5L89 0h67l356 55.7v66.7l-28.4 33.5 28.4 33.3V256l-26.6 32.2 26.6 34.6v66.8L485 421l27 35.3V512H0v-55.7l27.2-34.2L0 389.6v-66.8L30.6 251 0 189.2z","key":0}),React.createElement("path",{"fill":"#338af3","d":"M0 0v122.5h89V0zm155.9 0v122.4H256V55.7h256V0H155.9zM256 122.4v66.8h256v-66.8zm0 66.8H155.9V256H89v-66.8H0v133.6h512V256H256zM0 389.6v66.7h512v-66.7z","key":1})])]);
}

Gr.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Gr;

Gr.default = Gr;
